<template>
  <v-card class="d-flex flex-column align-center justify-center pa-5">
    <v-card-title class="mb-5">Νέο ΑΕΔΑΚ</v-card-title>
    <v-form @submit.prevent class="form d-flex flex-column justify-center">
      <v-text-field
        label="Όνομα"
        v-model="mmfManagerNationalName"
        class="rounded text-body-1 font-weight-regular"
        :error-messages="mmfManagerNationalNameErrors"
      >
      </v-text-field>

      <v-text-field
        label="Όνομα GLEIF"
        v-model="mmfManagerGLEIFName"
        class="rounded text-body-1 font-weight-regular"
        :error-messages="mmfManagerGLEIFNameErrors"
      >
      </v-text-field>

      <v-text-field
        label="Κωδικός"
        v-model="mmfManagerNationalCode"
        class="rounded text-body-1 font-weight-regular"
        :error-messages="mmfManagerNationalCodeErrors"
      >
      </v-text-field>

      <v-text-field
        label="Έδρα"
        v-model="mmfManagerDomicile"
        class="rounded text-body-1 font-weight-regular mb-4"
        :error-messages="mmfManagerDomicileErrors"
      >
      </v-text-field>

      <v-text-field
        label="LEI"
        v-model="mmfManagerLEI"
        class="rounded text-body-1 font-weight-regular"
        :error-messages="mmfManagerLEIErrors"
      >
      </v-text-field>

      <div class="d-flex justify-center">
        <v-btn
          type="submit"
          class="success rounded text-sm-body-1 font-weight-regular mr-5"
          :loading="loader"
          @click="onSubmit"
        >
          <span>Προσθήκη</span>
        </v-btn>
        <v-btn
          class="secondary rounded text-sm-body-1 font-weight-regular"
          @click="$emit('closeDialog')"
        >
          <span>Επιστροφή</span>
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      mmfManagerNationalCode: "",
      mmfManagerLEI: "",
      mmfManagerNationalName: "",
      mmfManagerGLEIFName: "",
      mmfManagerDomicile: "",
      loader: false,
    };
  },

  validations: {
    mmfManagerNationalCode: { required },
    mmfManagerLEI: { required },
    mmfManagerNationalName: { required },
    mmfManagerGLEIFName: { required },
    mmfManagerDomicile: { required },
  },

  computed: {
    mmfManagerNationalCodeErrors() {
      const errors = [];
      if (!this.$v.mmfManagerNationalCode.$dirty) return errors;
      if (!this.$v.mmfManagerNationalCode.required)
        errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfManagerLEIErrors() {
      const errors = [];
      if (!this.$v.mmfManagerLEI.$dirty) return errors;
      if (!this.$v.mmfManagerLEI.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfManagerNationalNameErrors() {
      const errors = [];
      if (!this.$v.mmfManagerNationalName.$dirty) return errors;
      if (!this.$v.mmfManagerNationalName.required)
        errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfManagerGLEIFNameErrors() {
      const errors = [];
      if (!this.$v.mmfManagerGLEIFName.$dirty) return errors;
      if (!this.$v.mmfManagerGLEIFName.required)
        errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfManagerDomicileErrors() {
      const errors = [];
      if (!this.$v.mmfManagerDomicile.$dirty) return errors;
      if (!this.$v.mmfManagerDomicile.required)
        errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
  },

  methods: {
    async onSubmit() {
      try {
        this.$v.$touch();
        if (this.$v.$invalid) return;
        this.loader = true;

        await axios.post(
          `${process.env.VUE_APP_BASE_URL}/admin/addcreditinstitute`,
          {
            mmfManagerNationalCode: this.mmfManagerNationalCode,
            mmfManagerLEI: this.mmfManagerLEI,
            mmfManagerNationalName: this.mmfManagerNationalName,
            mmfManagerGLEIFName: this.mmfManagerGLEIFName,
            mmfManagerDomicile: this.mmfManagerDomicile,
          }
        );

        this.loader = false;

        this.$store.commit("toggleSnackbar", {
          open: true,
          color: "success",
          text: "Η προσθήκη ΑΕΔΑΚ ολοκληρώθηκε με επιτυχία!",
        });

        await this.$emit("getCreditInstitutes");
        this.$emit("closeDialog");
      } catch (e) {
        console.log(e);
        this.loader = false;
      }
    },
  },
};
</script>

<style>
</style>